import { ACCOUNT_CURRENCY } from './../../../models/User';
import { AuthService } from './../../../abstraction/auth.service';
import { AddAccountComponent } from './add-account/add-account.component';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from '../../../../../modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AddCryptoAccountComponent } from './add-crypto-account/add-crypto-account.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlingService } from '../../../services/utils/error-handling.service';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss'],
})
export class AccountsComponent implements OnInit {
  public fiatAccounts = [];
  public cryptoAccounts = [];
  public resultSearch: any;

  constructor(
    private dialog: MatDialog,
    public auth: AuthService,
    private errorhandling: ErrorHandlingService,
  ) {}

  ngOnInit(): void {
    this.auth.loggedUserObs.subscribe(() => {
      this.refreshLists();
    });
  }

  refreshLists(): void {
    this.fiatAccounts = [];
    this.cryptoAccounts = [];

    this.auth.getAccounts(0).find((account) => {
      this.fiatAccounts.push({
        ...account,
        coin: 'USD',
      });
    });
    this.auth.getAccounts(1).find((account) => {
      this.fiatAccounts.push({
        ...account,
        coin: 'ARS',
      });
    });

    this.auth.getCryptoAccounts(0)?.find((account) => {
      this.cryptoAccounts.push({
        ...account,
        coin: 'ETH',
      });
    });
    this.auth.getCryptoAccounts(1)?.find((account) => {
      this.cryptoAccounts.push({
        ...account,
        coin: 'BSC',
      });
    });
    this.auth.getCryptoAccounts(2)?.find((account) => {
      this.cryptoAccounts.push({
        ...account,
        coin: 'LUNA',
      });
    });
    this.auth.getCryptoAccounts(4)?.find((account) => {
      this.cryptoAccounts.push({
        ...account,
        coin: 'POLYGON',
      });
    });
  }

  handlerChangeSearch(results: any): void {
    this.resultSearch = results;
  }

  addAccount(isFiat: boolean) {
    if (isFiat) {
      this.dialog
        .open(AddAccountComponent, {
          panelClass: 'modal-add-account',
          data: {
            title: `Agregá una cuenta en pesos/dólares`,
          },
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.errorHandler(res);
          }
        });
    } else {
      this.dialog
        .open(AddCryptoAccountComponent, {
          panelClass: 'modal-add-account',
          data: {
            title: `Agregá una cuenta en Crypto`,
          },
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.errorHandler(res);
          }
        });
    }
  }

  deleteFiatAccount({ cbu, description, coin }) {
    coin = coin.toUpperCase();
    this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Eliminar cuenta',
          content: `Estás por eliminar <b>${description || 'Cuenta sin nombre'}</b> de tus cuentas`,
          isError: true,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.auth
            .removeAccount(cbu, ACCOUNT_CURRENCY[coin])
            .subscribe(() => {}, this.errorHandler.bind(this));
        }
      });
  }

  deleteCryptoAccount({ description, address, chain }) {
    this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Eliminar cuenta',
          content: `Estás por eliminar <b>${description || 'Cuenta sin nombre'}</b> de tus cuentas`,
          isError: true,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.auth
            .removeCryptoAccount(address, chain)
            .subscribe(() => {}, this.errorHandler.bind(this));
        }
      });
  }

  errorHandler(error: HttpErrorResponse) {
    this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
      panelClass: 'modal-container',
      data: this.errorhandling.handleAccountError(error),
    });
  }
}
